import { z } from 'zod';

export const fileSystemObjectSchema = z.object({
    content: z.string().optional(),
    size: z.number(),
    type: z.enum(['file', 'directory']),
});

export type FileSystemObject = z.infer<typeof fileSystemObjectSchema>;

export const fileCacheSchema = z.record(z.string(), fileSystemObjectSchema);

export type FileCache = z.infer<typeof fileCacheSchema>;
